import { Box, HeadingText } from '@leagueplatform/genesis-core';
import { Table } from '../components/table/Table';
import { FilterToolbar } from '../components/filter-toolbar/FilterToolbar';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useFilterStore } from '../state/useFilterStore';
import { parseQueryParams } from '../utils/parseQueryParams';

export function Home() {
  const [searchParams] = useSearchParams();
  const { setFilters, setSearchValue } = useFilterStore();

  // Set initial filters from search params on mount
  useEffect(() => {
    const filters = parseQueryParams(searchParams);
    const { s, ...rest } = filters;
    setFilters(rest);
    if (s) {
      setSearchValue(s);
    }
  }, [searchParams, setFilters, setSearchValue]);

  return (
    <Box
      css={{
        maxWidth: '1440px',
        margin: '80px auto',
      }}
    >
      <HeadingText level="1" size="xxl">
        Analytics Data Dictionary
      </HeadingText>

      <FilterToolbar />
      <Table />
    </Box>
  );
}
